import { createColumnHelper } from '@tanstack/react-table';
import {
  InsightsTableCell,
  InsightsTableRow
} from '../types/insights-table.types';
import InsightsTableAccordion from '../insights-table-accordion';
import { AdvancedReportMetricRow } from 'features/advanced-reports/advanced-reports.types';

function toPercentage(value: number, total: number): string {
  const percentageValue = (value / total) * 100;

  if (isNaN(percentageValue)) {
    return '';
  }
  return `${Math.round(percentageValue)}%`;
}

const calculateTotalValue = (
  tableData?: AdvancedReportMetricRow[],
  dataIsLoading?: boolean
): number => {
  let total = 0;
  if (!dataIsLoading && tableData) {
    total = tableData!
      .filter((row) => row.metricParentId === '')
      .reduce((accumulator, currentObject) => {
        return accumulator + currentObject.metricValue;
      }, 0);
  }
  return total;
};

const columnHelper = createColumnHelper<InsightsTableRow>();

export const getConversionInfluenceInsightColumnDefs = (
  allRows?: AdvancedReportMetricRow[],
  isDataLoading?: boolean
) => {
  return [
    columnHelper.accessor('field', {
      id: 'Field',
      cell: (info) =>
        createInsightsFieldCell(
          info.getValue(),
          info.row.original.id,
          info.row.original.hasChildren
        ),
      header: 'Field',
      enableColumnFilter: false,
      enableSorting: false
    }),
    columnHelper.accessor('occurrences', {
      id: 'Occurrences',
      cell: (info) => info.getValue().primaryValue,
      enableColumnFilter: false,
      enableSorting: false
    }),
    columnHelper.accessor('occurrences', {
      id: 'Percentage',
      cell: (info) =>
        toPercentage(
          +info.getValue().primaryValue,
          +calculateTotalValue(allRows, isDataLoading)
        ),
      header: 'Percentage',
      enableColumnFilter: false,
      enableSorting: false
    })
  ];
};

export const createInsightsFieldCell = (
  value: string,
  rowId: string,
  rowHasChildren: boolean
) => (
  <div className="relative flex items-center">
    <div className="flex mx-2 w-4 h-4">
      <InsightsTableAccordion rowId={rowId} isHidden={!rowHasChildren} />
    </div>
    {value}
  </div>
);

export const createOccurrencesCell = (cell: InsightsTableCell) => (
  <div>
    <div className="text-sm overflow-hidden block">
      {Intl.NumberFormat('en-GB', {
        maximumFractionDigits: 2
      }).format(cell.primaryValue)}
    </div>
  </div>
);
